"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _commonCta = require("@mmc/common-cta");
var _commonI18n = require("@mmc/common-i18n");
var _formElements = require("@mmc/form-elements");
var _paymentCalculatorForm = require("@mmc/payment-calculator-form");
var _commonDrawer = require("@mmc/common-drawer");
var _financeSummary = _interopRequireDefault(require("../styles/finance-summary.css"));
var _configuratorLargeSummary = require("./configurator-large-summary.props/configurator-large-summary.propTypes");
var _commonLibs = require("@mmc/common-libs");
var _commonSetLocation = require("@mmc/common-set-location");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FinanceSummary = function FinanceSummary(_ref) {
  var theme = _ref.theme,
    market = _ref.market,
    config = _ref.config,
    summaryFinanceData = _ref.summaryFinanceData,
    summary = _ref.summary,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    additionalPriceGroup = _ref.additionalPriceGroup;
  // Example finance
  // {
  //   buyFor: 250,
  //   buyPaymentFrequency: 200,
  //   leaseFor: 200,
  //   leasePaymentFrequency: 200,
  //   suffix: 'm/o', // Backward compatibility with Payment Calculator v1
  //   calculatorData: {
  //     annualMileage: 5000,
  //     tradeInValue: 1.12,
  //     rate: 100,
  //     downPaymentAmount: 2000,
  //     leaseTerm: 72,
  //     financeTerm: 72,
  //     financeTerms: [24, 48, 72],
  //     leaseTerms: [24, 48, 72],
  //   }
  // }
  var _useState = (0, _react.useState)({}),
    finance = _useState[0],
    setFinance = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    isDatalayerUpdated = _useState2[0],
    setIsDatalayerUpdated = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    isCalculatorPopupOpen = _useState3[0],
    setIsCalculatorPopupOpen = _useState3[1];
  var isUS = market === 'us';
  var isCA = market === 'ca';
  var labels = summaryFinanceData.labels,
    fullVehicleName = summaryFinanceData.fullVehicleName,
    totalPrice = summaryFinanceData.totalPrice,
    clickShopEnabled = summaryFinanceData.clickShopEnabled;
  var msrpDisclaimerId = summary.msrpDisclaimerId,
    monthlyMsrpDisclaimerId = summary.monthlyMsrpDisclaimerId,
    buyMonthlyDisclaimerId = summary.buyMonthlyDisclaimerId,
    interestRateDisclaimerId = summary.interestRateDisclaimerId,
    leaseMonthlyDisclaimerId = summary.leaseMonthlyDisclaimerId,
    annualMileageDisclaimerId = summary.annualMileageDisclaimerId,
    dueAtLeaseSigningDisclaimerId = summary.dueAtLeaseSigningDisclaimerId,
    destinationFeesDisclaimerId = summary.destinationFeesDisclaimerId;
  var _ref2 = finance || {},
    leaseFor = _ref2.leaseFor,
    leasePaymentFrequency = _ref2.leasePaymentFrequency,
    leasePaymentFrequencyOptions = _ref2.leasePaymentFrequencyOptions,
    buyFor = _ref2.buyFor,
    buyPaymentFrequency = _ref2.buyPaymentFrequency,
    buyPaymentFrequencyOptions = _ref2.buyPaymentFrequencyOptions,
    suffix = _ref2.suffix;
  var disclaimerGroup = {
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: priceDisclaimerId,
    disclaimerData: disclaimerData,
    msrpDisclaimerId: msrpDisclaimerId,
    monthlyMsrpDisclaimerId: monthlyMsrpDisclaimerId,
    buyMonthlyDisclaimerId: buyMonthlyDisclaimerId,
    interestRateDisclaimerId: interestRateDisclaimerId,
    leaseMonthlyDisclaimerId: leaseMonthlyDisclaimerId,
    annualMileageDisclaimerId: annualMileageDisclaimerId,
    dueAtLeaseSigningDisclaimerId: dueAtLeaseSigningDisclaimerId,
    destinationFeesDisclaimerId: destinationFeesDisclaimerId
  };
  var handleFinance = function handleFinance(newData) {
    // Prevent infinite rerender loop
    if (!(0, _isEqual2["default"])(_objectSpread(_objectSpread({}, finance), newData), finance)) {
      setFinance(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), newData);
      });
    }
  };
  var getSelectedPaymentFrequencyLabel = function getSelectedPaymentFrequencyLabel(targetValue, options) {
    var _options$find;
    return options == null ? void 0 : (_options$find = options.find(function (option) {
      return option.value === targetValue;
    })) == null ? void 0 : _options$find.label;
  };
  var financePaymentFreqLabel = getSelectedPaymentFrequencyLabel(leasePaymentFrequency, leasePaymentFrequencyOptions);
  var leasePaymentFreqLabel = getSelectedPaymentFrequencyLabel(buyPaymentFrequency, buyPaymentFrequencyOptions);
  var updateDatalayer = function updateDatalayer(summary, summaryFinanceData, finance, market) {
    if (!isDatalayerUpdated && Object.keys(finance).length > 0) {
      var _window$location$sear;
      if (market.toLowerCase() === 'ca' && typeof window !== 'undefined' && window.dataLayer && ['/en/buy/configure-your-mitsubishi/configurator', '/fr/acheter/configuration-et-prix/configurator'].includes(window.location.pathname) && (_window$location$sear = window.location.search) != null && _window$location$sear.includes('step=SummarySelector')) {
        var _summary$vehicle, _summary$accessories, _summary$model, _summary$model2, _summary$model2$name, _summary$color, _summary$color$code, _summary$fabric, _summary$fabric$code;
        var nameplate = (0, _commonLibs.getNameplateByVehicleName)(summary == null ? void 0 : (_summary$vehicle = summary.vehicle) == null ? void 0 : _summary$vehicle.name);
        var accessories = summary == null ? void 0 : (_summary$accessories = summary.accessories) == null ? void 0 : _summary$accessories.map(function (acc) {
          var _acc$label;
          return (_acc$label = acc.label) == null ? void 0 : _acc$label.toLowerCase();
        }).join(', ');
        var _getCachedLocation = (0, _commonSetLocation.getCachedLocation)(),
          stateCode = _getCachedLocation.stateCode,
          postalCode = _getCachedLocation.postalCode,
          city = _getCachedLocation.city;
        var dataCollection = {
          event: "bnp_summary",
          nameplate: nameplate,
          vehicle_year: summary == null ? void 0 : (_summary$model = summary.model) == null ? void 0 : _summary$model.year,
          vehicle_trim: summary == null ? void 0 : (_summary$model2 = summary.model) == null ? void 0 : (_summary$model2$name = _summary$model2.name) == null ? void 0 : _summary$model2$name.toLowerCase(),
          exterior_colour: summary == null ? void 0 : (_summary$color = summary.color) == null ? void 0 : (_summary$color$code = _summary$color.code) == null ? void 0 : _summary$color$code.toLowerCase(),
          interior_colour: summary == null ? void 0 : (_summary$fabric = summary.fabric) == null ? void 0 : (_summary$fabric$code = _summary$fabric.code) == null ? void 0 : _summary$fabric$code.toLowerCase(),
          accessories: accessories,
          msrp: summaryFinanceData.totalPrice,
          finance_monthly: finance == null ? void 0 : finance.buyFor,
          lease_monthly: finance == null ? void 0 : finance.leaseFor,
          vehicle_category_code: _commonLibs.VEHICLE_CATEGORY_CODES[nameplate],
          province: stateCode == null ? void 0 : stateCode.toLowerCase(),
          postal_code: postalCode == null ? void 0 : postalCode.toUpperCase(),
          city: city == null ? void 0 : city.toLowerCase()
        };
        dataCollection = (0, _commonLibs.cleanObject)(dataCollection);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataCollection);
        setIsDatalayerUpdated(true);
      }
    }
  };
  (0, _react.useEffect)(function () {
    updateDatalayer(summary, summaryFinanceData, finance, market);
  }, [finance]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _financeSummary["default"].financeSummaryContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _financeSummary["default"].totals
  }, finance && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: theme.smallType
  }, labels.lease + " ", leaseFor ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: _financeSummary["default"].totalPriceIncl
  }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: leaseFor,
      currency: config.currencyFormat,
      locale: config.localeCode,
      displayValue: null
    },
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: leaseMonthlyDisclaimerId,
    disclaimerData: disclaimerData
  })), ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: _financeSummary["default"].leaseAmSuffix
  }, financePaymentFreqLabel || suffix)) : '-'), /*#__PURE__*/_react["default"].createElement("span", {
    className: theme.smallType
  }, labels.buy + " ", buyFor ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: _financeSummary["default"].totalPriceIncl
  }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: buyFor,
      currency: config.currencyFormat,
      locale: config.localeCode,
      displayValue: null
    },
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: buyMonthlyDisclaimerId,
    disclaimerData: disclaimerData
  })), ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: _financeSummary["default"].leaseAmSuffix
  }, leasePaymentFreqLabel || suffix)) : '-'), /*#__PURE__*/_react["default"].createElement("span", {
    className: theme.smallType
  }, labels.msrp + " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: _financeSummary["default"].totalPriceIncl
  }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: totalPrice,
      currency: config.currencyFormat,
      locale: config.localeCode,
      displayValue: null
    },
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: msrpDisclaimerId,
    disclaimerData: disclaimerData
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _financeSummary["default"].financeCta
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    clickEvent: function clickEvent() {
      return setIsCalculatorPopupOpen(true);
    },
    data: {
      label: labels.title,
      priority: 'trivial'
    }
  })), /*#__PURE__*/_react["default"].createElement(_commonDrawer.CommonDrawer, {
    visible: isCalculatorPopupOpen,
    onClose: function onClose() {
      return setIsCalculatorPopupOpen(false);
    },
    prerender: true,
    isPopover: true,
    contentClassName: _financeSummary["default"].drawerContent
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-md-10'], _financeSummary["default"].calculatorHeading)
  }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.title), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_financeSummary["default"].calculatorTitle)
  }, /*#__PURE__*/_react["default"].createElement("h3", null, fullVehicleName), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx["default"])(theme.smallType, _financeSummary["default"].breakdownPrice)
  }, (isUS || isCA) && labels.suffix, ' ', /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: totalPrice,
      currency: config.currencyFormat,
      locale: config.localeCode,
      displayValue: null
    },
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: msrpDisclaimerId,
    disclaimerData: disclaimerData
  })))), /*#__PURE__*/_react["default"].createElement(_paymentCalculatorForm.CalculationForm, {
    isNgc: true,
    isSmallForm: true,
    hasLinks: true,
    clickShopEnabled: clickShopEnabled,
    market: market,
    theme: theme,
    updatePriceHoc: handleFinance,
    combinedStepsLabels: labels,
    disclaimerGroup: disclaimerGroup,
    additionalPriceGroup: additionalPriceGroup
  }))));
};
FinanceSummary.displayName = 'FinanceSummary';
var _default = FinanceSummary;
exports["default"] = _default;